import { useLocation } from "react-router";
import "./sidebar.css";
import { useNavigate } from "react-router";

export default function SideBar() {
  const location = useLocation();
  const navigate = useNavigate();

  const storedData = localStorage.getItem("adminData") || "{}";
  const adminData = JSON.parse(storedData);
  const role = adminData.Role || null;

  return (
    <div className="sidebar">
      <div className="sidebar-links">
        {role === "Admin" || role === "SuperAdmin" ? (
          <>
            <button
              onClick={() => navigate("/admin/")}
              className={
                location.pathname === "/admin/"
                  ? "nav-link active"
                  : "nav-link"
              }
            >
              Home
            </button>
            <button
              onClick={() => navigate("/admin/about-us")}
              className={
                location.pathname === "/admin/about-us"
                  ? "nav-link active"
                  : "nav-link"
              }
            >
              About us
            </button>
            <button
              onClick={() => navigate("/admin/blog")}
              className={
                location.pathname === "/admin/blog" ? "nav-link active" : "nav-link"
              }
            >
              Blog
            </button>
            <button
              onClick={() => navigate("/admin/blogcomment")}
              className={
                location.pathname === "/admin/blogcomment"
                  ? "nav-link active"
                  : "nav-link"
              }
            >
              Blog Comments
            </button>
            <button
              onClick={() => navigate("/admin/blogcommentstatus")}
              className={
                location.pathname === "/admin/blogcommentstatus"
                  ? "nav-link active"
                  : "nav-link"
              }
            >
              Blog Comment Status
            </button>

            <button
              onClick={() => navigate("/admin/shop")}
              className={
                location.pathname === "/admin/shop" ? "nav-link active" : "nav-link"
              }
            >
              Shop
            </button>
            <button
              onClick={() => navigate("/admin/shopcomment")}
              className={
                location.pathname === "/admin/shopcomment"
                  ? "nav-link active"
                  : "nav-link"
              }
            >
              Shop Comments
            </button>
            <button
              onClick={() => navigate("/admin/shopcommentstatus")}
              className={
                location.pathname === "/admin/shopcommentstatus"
                  ? "nav-link active"
                  : "nav-link"
              }
            >
              Shop Comments Status
            </button>
            <button
              onClick={() => navigate("/admin/contactus")}
              className={
                location.pathname === "/admin/contactus"
                  ? "nav-link active"
                  : "nav-link"
              }
            >
              Contact Us
            </button>
            <button
              onClick={() => navigate("/admin/newsletter")}
              className={
                location.pathname === "/admin/newsletter"
                  ? "nav-link active"
                  : "nav-link"
              }
            >
              News Letter
            </button>
            {role === "SuperAdmin" && (
              <button
                onClick={() => navigate("/admin/admin-users")}
                className={
                  location.pathname === "/admin/admin-users"
                    ? "nav-link active"
                    : "nav-link"
                }
              >
                Admin users
              </button>
            )}
            <button onClick={() => navigate("/admin/logout")}>Log out</button>
          </>
        ) : role === "Blogger" ? (
          <>
            <button onClick={() => navigate("/admin/blog")}>Blog</button>
            <button onClick={() => navigate("/admin/blogcomment")}>
              Blog Comments
            </button>
            <button onClick={() => navigate("/admin/logout")}>Log out</button>
          </>
        ) : (
          <button onClick={() => navigate("/admin/logout")}>Log out</button>
        )}
      </div>
    </div>
  );
}
